import { Component } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";

import Img from "../assets/clock.svg";
import Styles from "bundle-text:../styles/_greatModal.scss";

interface GreatModalProps {
  show: boolean;
  onNext: () => void;
}

const GreatModal: Component<GreatModalProps> = (props) => {
  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show}>
        <div className="great-content">
          <h1>Great! Your domain is configured.</h1>
          <p>
            Your domain, http://xyz.com, has been configured and we will notify
            you when the propagation process is complete.  In some cases,
            propagation can take up to 48 hours.
          </p>
          <img src={Img} alt="clock" />
          <button onClick={props.onNext}>Next</button>
        </div>
      </DefaultModal>
    </>
  );
};

export default GreatModal;
